export const splitLabel = (label?: string, maxLength = 15) => {
  if (!label) {
    return [];
  }
  const words = label.split(' ');

  let lines: string[] = [];
  let currentLine = '';

  words.forEach((word) => {
    if (word.length > maxLength) {
      const safeMaxLength = Math.max(1, Math.min(100, maxLength)); // Limiting the reasonable range
      const regex = new RegExp(`.{1,${safeMaxLength}}`, 'g'); // create a regular expression only after validation
      const chunks = word.match(regex) || [];
      lines = lines.concat(chunks);
    } else {
      if ((currentLine + ' ' + word).trim().length > maxLength) {
        lines.push(currentLine.trim());
        currentLine = word;
      } else {
        currentLine = currentLine ? currentLine + ' ' + word : word;
      }
    }
  });

  if (currentLine) {
    lines.push(currentLine.trim());
  }

  return lines;
};

export const calculatePadding = (allValues: string[], unit: string): number => {
  const PADDING_PER_CHAR = 12;
  const unitLength = unit.length;

  const maxValueLength = allValues.reduce((max, value) => Math.max(max, value.length), 0);

  if (maxValueLength === unitLength) {
    return PADDING_PER_CHAR;
  }
  if (maxValueLength < unitLength) {
    return PADDING_PER_CHAR * Math.abs(maxValueLength - unitLength);
  }
  return 0;
};
